import { Box } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { Badge } from "components";
import Typography from "components/Typography";
import { gray } from "configs/colors";
import { RequestCandidateEntity, RequestEntity } from "generated";
import { formatDate } from "helpers/dayjs";
import {
  getColorRequestCandidateEntityStatus,
  getColorRequestEntityStatus,
  isJson,
} from "helpers/string";
import { Link } from "react-router-dom";

export const requestColumn: GridColDef<RequestEntity>[] = [
  {
    field: "name",
    headerName: "Name",
    width: 250,
    renderCell: (params: GridRenderCellParams<RequestEntity>) => {
      return (
        <Link
          to={`/request/detail/${params?.row?.id as string}`}
          style={{ textDecoration: "none" }}
          className="item-url"
        >
          {params?.row?.name}
        </Link>
      );
    },
  },
  {
    field: "code",
    headerName: "Request Code",
    width: 200,
  },
  {
    field: "contractor",
    headerName: "Contractor",
    width: 200,
  },
  // {
  //   field: "template",
  //   headerName: "Template",
  //   width: 200,
  //   renderCell: (params: GridRenderCellParams<RequestEntity>) => {
  //     return (
  //       <Box>
  //         <Typography type="TextSM" color={gray[900]}>
  //           {params?.row?.template?.name}
  //         </Typography>
  //         <Typography type="TextSM" color={gray[600]}>
  //           {params?.row?.template?.code}
  //         </Typography>
  //       </Box>
  //     ); /// eslint-disable-line
  //   },
  // },
  {
    field: "pic",
    headerName: "PIC",
    width: 250,
    renderCell: (params: GridRenderCellParams<RequestEntity>) => {
      return (
        <Box>
          <Typography type="TextSM" color={gray[900]}>
            {params?.row?.pic?.fullName}
          </Typography>
          <Typography type="TextSM" color={gray[600]}>
            {params?.row?.pic?.email}
          </Typography>
        </Box>
      ); /// eslint-disable-line
    },
  },
  {
    field: "assigneeDate",
    headerName: "Assigned Date",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestEntity>) => {
      return formatDate(params?.row?.createdAt); // eslint-disable-line
    },
  },
  {
    field: "dueDate",
    headerName: "Due Date",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestEntity>) => {
      return formatDate(params?.row?.dueDate); // eslint-disable-line
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestEntity>) => {
      return (
        <Badge
          dot
          size="small"
          color={getColorRequestEntityStatus(params?.row?.status)} // eslint-disable-line
        >
          {params?.row?.status}
        </Badge>
      );
    },
  },
];
export const requestCandidateColumn: GridColDef<RequestCandidateEntity>[] = [
  // {
  //   field: "candidateName",
  //   headerName: "Name",
  //   width: 250,
  //   renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
  //     return (
  //       <Link
  //         to={`/request/detail/${params?.row?.requestId}`}
  //         style={{ textDecoration: "none" }}
  //         className="item-url"
  //       >
  //         {params?.row?.candidateName}
  //       </Link>
  //     );
  //   },
  // },
  {
    field: "code",
    headerName: "Document Check Code",
    width: 200,
  },
  {
    field: "templateType",
    headerName: "Template Type",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return params?.row?.template?.templateType?.name as string;
    },
  },

  {
    field: "template",
    headerName: "Template",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return (
        <Box>
          <Typography type="TextSM" color={gray[900]}>
            {params?.row?.template?.name}
          </Typography>
          <Typography type="TextSM" color={gray[600]}>
            {params?.row?.template?.code}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "assigneeDate",
    headerName: "Assigned Date",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return formatDate(params?.row?.request?.createdAt);
    },
  },
  {
    field: "dueDate",
    headerName: "Due Date",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return formatDate(params?.row?.request?.dueDate);
    },
  },
  {
    field: "candidateCV",
    headerName: "Candidate's CV",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return (
        <Box>
          <Typography type="TextSM" color={gray[900]}>
            {params?.row?.fileUrl && isJson(params?.row?.fileUrl ?? "") //eslint-disable-line
              ? JSON.parse(params?.row?.fileUrl)?.originalName
              : ""}
          </Typography>
          <Typography type="TextSM" color={gray[600]}>
            {params?.row?.candidateName}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "candidateEmail",
    headerName: "Email",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return params?.row?.email;
    },
  },
  {
    field: "candidatePhone",
    headerName: "Phone",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return params?.row?.phoneNumber && isJson(params?.row?.phoneNumber)
        ? (JSON.parse(params?.row?.phoneNumber)?.numberValue as string)
        : "";
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 200,
    renderCell: (params: GridRenderCellParams<RequestCandidateEntity>) => {
      return (
        <Badge
          dot
          size="small"
          color={getColorRequestCandidateEntityStatus(params?.row?.status)} // eslint-disable-line
        >
          {params?.row?.status}
        </Badge>
      );
    },
  },
];
